import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap';
import _ from 'lodash';
import appConfig from '../../appConfig';
import AddIcon from '../../../icons/toolbar-icons/add.svg';
const getDisplayName = (groupName) => {
  let displayGroupName = groupName;
  if (appConfig.setSchemaName) {
    if (
      appConfig.setSchemaName.schemaName &&
      appConfig.setSchemaName.schemaName.toUpperCase() ===
        groupName.toUpperCase()
    ) {
      displayGroupName = appConfig.setSchemaName.displayTitle;
    } else if (Array.isArray(appConfig.setSchemaName)) {
      const cur = appConfig.setSchemaName.find(
        (item) => item.schemaName.toUpperCase() === groupName.toUpperCase()
      );
      if (cur) displayGroupName = cur.displayTitle;
    }
  }
  return displayGroupName;
};

function MetadataViewGroup({ metaItems, umoID }) {
  const metaGroup = [];
  const metaGroupComponent = [];

  for (let i = 0; i < metaItems.length; i++) {
    const groupName = metaItems[i].props.metadata.category;
    if (metaGroup.indexOf(groupName) < 0) metaGroup.push(groupName);
  }
  for (let i = 0; i < metaGroup.length; i++) {
    let grpStyle;
    if (appConfig.autoExpandMetaSchema) {
      const schemasToExpand = _.isArray(appConfig.autoExpandMetaSchema)
        ? appConfig.autoExpandMetaSchema
        : [appConfig.autoExpandMetaSchema];
      grpStyle =
        schemasToExpand.findIndex(
          (item) => metaGroup[i].toLowerCase() === item.toLowerCase()
        ) !== -1
          ? { display: 'block' }
          : { display: 'none' };
    }

    const metaGroupTags = [];
    for (let k = 0; k < metaItems.length; k++) {
      if (metaItems[k].props.metadata.category === metaGroup[i])
        metaGroupTags.push(metaItems[k]);
    }

    metaGroupComponent.push(
      <div
        key={`group_${metaGroup[i]}`}
        className="umo-detail-view__meta-group card card-default"
      >
        <div
          className="umo-detail-view__meta-group-heading card-header"
          role="tab"
        >
          <div
            role="button"
            onClick={() => {
              $(`div[id='${umoID}_${metaGroup[i]}_collapse']`).toggle();
            }}
          >
            <div className="umo-detail-view__meta-group-title card-title font-md-regular">
              <img src={AddIcon} />
              {getDisplayName(metaGroup[i])}
            </div>
          </div>
        </div>
        <div
          id={`${umoID}_${metaGroup[i]}_collapse`}
          className="card-collapse collapse"
          role="tabpanel"
          style={grpStyle}
        >
          <div className="umo-detail-view__meta-group-body card-body">
            {metaGroupTags}
          </div>
        </div>
      </div>
    );
  }

  return <Accordion>{metaGroupComponent}</Accordion>;
}

MetadataViewGroup.propTypes = {
  metaItems: PropTypes.instanceOf(Array),
  umoID: PropTypes.string,
};

export default MetadataViewGroup;
